<template>
    <div class="inspiration-area ptb-100">
        <div class="container">
            <div class="section-title" data-aos="fade-up">
                <span class="sub-title">Lassen Sie sich inspirieren</span>
                <h2>Was möglich ist</h2>
                <p>Hochwertige Projekte als möglicher Ausgangspunkt für Ihr Projekt</p>
            </div>

            <div class="showcase-grid">
                <div
                    class="showcase-item"
                    v-for="(template, index) in templates"
                    :key="template.id"
                    data-aos="fade-up"
                    :data-aos-delay="index * 150"
                >
                    <div class="browser-mockup">
                        <div class="browser-header">
                            <div class="browser-dots">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div class="browser-url">{{ template.previewUrl }}</div>
                        </div>
                        <div class="browser-content">
                            <img :src="template.image" :alt="template.title" />
                            <div class="showcase-overlay">
                                <a :href="template.liveUrl" target="_blank" rel="noopener noreferrer" class="preview-btn">
                                    <i class="bx bx-link-external"></i>
                                    Live ansehen
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="showcase-info">
                        <span class="industry-badge">{{ template.industry }}</span>
                        <h3>{{ template.title }}</h3>
                        <p>{{ template.description }}</p>
                    </div>
                </div>
            </div>

            <div class="section-title" style="text-transform:none; margin-top: 4em" data-aos="fade-up">
                <p>Diese Vorlagen entstanden aus realen Kundenprojekten und echten Anforderungen.<br>Aus Datenschutzgründen wurden Inhalte anonymisiert und Bildmaterial reduziert dargestellt – betrachten Sie dies als Einladung, Ihre eigene Vision einzubringen.</p>
                <hr>
                <p>Ihnen gefällt eine der Ideen oder einzelne Elemente aber es ist nicht Ihre Branche? Kein Problem! Dies sind nur Beispiele und können 100% individuell angepasst werden.</p>
                <router-link to="/contact" class="default-btn">
                    <i class="bx bxs-edit-alt"></i>
                    Kontakt aufnehmen
                    <span></span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'InspirationShowcase',
    data() {
        return {
            templates: [
                {
                    id: 8,
                    industry: 'Gesundheitswesen',
                    title: 'Moderne Arztpraxis, Zahnarzt oder Klinik',
                    description: 'Professionelles Design für Arztpraxen, Zahnärzte oder Kliniken. Kontaktieren Sie mich für ein auf Sie zugeschnittenes Projekt.',
                    image: require('../../assets/img/projects/templates/med-healthcare.png'),
                    liveUrl: 'https://benovium-showcase-med-healthcare.vercel.app/',
                    previewUrl: 'med-healthcare.benovium-showcase.com',
                },
                {
                    id: 1,
                    industry: 'Agenturen & Dienstleister',
                    title: 'Agenturen & Dienstleister',
                    description: 'Vielseitiges Design für verschiedene Agenturen und/oder Dienstleister. Kontaktieren Sie mich für ähnliche Projekte.',
                    image: require('../../assets/img/projects/templates/multi-agency.png'),
                    liveUrl: 'https://benovium-showcase-multiagency.vercel.app/',
                    previewUrl: 'multi-agency.benovium-showcase.com',
                },
                {
                    id: 2,
                    industry: 'Immobilien',
                    title: 'Exklusives Immobilien-Angebot',
                    description: 'Modernes Design für Immobilien-Angebote. Kontaktieren Sie mich für ähnliche Projekte.',
                    image: require('../../assets/img/projects/templates/real-estate-single.png'),
                    liveUrl: 'https://benovium-showcase-real-estate-single.vercel.app/',
                    previewUrl: 'real-estate.benovium-showcase.com',
                },
                {
                    id: 3,
                    industry: 'Gastronomie',
                    title: 'Hochwertiges Restaurant',
                    description: 'Stilvolles Design für gehobene Restaurants. Kontaktieren Sie mich für ähnliche Projekte.',
                    image: require('../../assets/img/projects/templates/luxury-restaurant.png'),
                    liveUrl: 'https://benovium-showcase-luxury-restaurant.vercel.app/',
                    previewUrl: 'luxury-restaurant.benovium-showcase.com',
                },
                {
                    id: 4,
                    industry: 'Portfolio',
                    title: 'Hochzeits-Planer',
                    description: 'Elegante Portfolio-Vorlage für Hochzeits-Planer. Präsentieren Sie Ihre Dienstleistungen stilvoll und professionell.',
                    image: require('../../assets/img/projects/templates/wedding-planner.png'),
                    liveUrl: 'https://benovium-showcase-wedding-planner.vercel.app/',
                    previewUrl: 'wedding-planner.benovium-showcase.com',
                },
                {
                    id: 5,
                    industry: 'Immobilien',
                    title: 'Immobilien-Plattform',
                    description: 'Moderne Lösung für Immobilien-Plattformen. Kontaktieren Sie mich für ähnliche Projekte.',
                    image: require('../../assets/img/projects/templates/real-estate-platform.png'), 
                    liveUrl: 'https://benovium-showcase-real-estate-platform.vercel.app/',
                    previewUrl: 'real-estate-platform.benovium-showcase.com',
                },
                {
                    id: 6,
                    industry: 'Portfolio',
                    title: 'Variables Portfolio',
                    description: 'Moderne Portfolio-Vorlage für Kreative, Designer und Fotografen. Präsentieren Sie Ihre Arbeiten stilvoll und professionell.',
                    image: require('../../assets/img/projects/templates/anderson-portfolio.png'),
                    liveUrl: 'https://benovium-showcase-anderson-portfolio.vercel.app/',
                    previewUrl: 'anderson-portfolio.benovium-showcase.com',
                },
                {
                    id: 7,
                    industry: 'Gastronomie',
                    title: 'Eissalon',
                    description: 'Elegantes Design für Eissalons und Cafés. Kontaktieren Sie mich für ähnliche Projekte.',
                    image: require('../../assets/img/projects/templates/eissalon-template.png'), 
                    liveUrl: 'https://benovium-showcase-eissalon.vercel.app/',
                    previewUrl: 'eissalon.benovium-showcase.com',
                },
            ]
        }
    }
}
</script>

<style scoped>
.inspiration-area {
    background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
}

.showcase-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
}

.showcase-item {
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
    transition: all 0.4s ease;
}

.showcase-item:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.browser-mockup {
    background: #1a1a2e;
    overflow: hidden;
}

.browser-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: #0f0f1a;
    gap: 12px;
}

.browser-dots {
    display: flex;
    gap: 6px;
}

.browser-dots span {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #3a3a4a;
}

.browser-dots span:first-child {
    background: #ff5f57;
}

.browser-dots span:nth-child(2) {
    background: #ffbd2e;
}

.browser-dots span:last-child {
    background: #28ca41;
}

.browser-url {
    flex: 1;
    background: #2a2a3a;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 12px;
    color: #8a8a9a;
    font-family: monospace;
}

.browser-content {
    position: relative;
    overflow: hidden;
}

.browser-content img {
    width: 100%;
    height: 280px;
    object-fit: cover;
    object-position: top;
    display: block;
    transition: transform 0.4s ease;
    border-radius: 0;
}

.showcase-item:hover .browser-content img {
    transform: scale(1.02);
}

.showcase-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(1, 2, 21, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.showcase-item:hover .showcase-overlay {
    opacity: 1;
}

.preview-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #ffffff;
    color: #010215;
    padding: 14px 28px;
    border-radius: 30px;
    font-weight: 600;
    font-size: 14px;
    text-decoration: none;
    transition: all 0.3s ease;
}

.preview-btn:hover {
    background: #010215;
    color: #ffffff;
}

.preview-btn i {
    font-size: 18px;
}

.showcase-info {
    padding: 24px;
}

.industry-badge {
    display: inline-block;
    background: #010215;
    color: #ffffff;
    font-size: 11px;
    font-weight: 600;
    padding: 5px 14px;
    border-radius: 20px;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 12px;
}

.showcase-info h3 {
    font-size: 20px;
    font-weight: 700;
    color: #010215;
    margin-bottom: 8px;
}

.showcase-info p {
    font-size: 14px;
    color: #4a6f8a;
    line-height: 1.6;
    margin: 0;
}

/* Responsive */
@media (max-width: 992px) {
    .showcase-grid {
        grid-template-columns: 1fr;
        gap: 30px;
    }
}

@media (max-width: 576px) {
    .browser-content img {
        height: 200px;
    }
}
</style>
